import createHistory from 'history/createBrowserHistory'

export default createHistory()



// WEBPACK FOOTER //
// ./src/store/history.js